export const roundedMoney = (number) => {
  if (isNaN(number)) {
    return 0;
  }

  return Number.parseFloat(number.toFixed(2));
};

export const fromCents = (number) => {
  if (isNaN(number)) {
    return 0;
  }

  return (number / 100);
};

export const toCents = (number) => {
  if (isNaN(number)) {
    return 0;
  }

  return Math.round(number * 100);
};

export const toMoneyValue = (value) => {
  const parsed = Number.parseFloat(value);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const formatMoneyFromSubunits = (value, currency = 'USD') => {
  const amount = toMoneyValue(value);
  const fractionDigits = Number.isInteger(amount) ? 2 : 4;
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });

  return formatter.format(amount / 100);
};
